import React from 'react';

const TrabajosSection2 = () => {
    return (
        <div className="container max-w-screen-lg mx-auto p-6 bg-black min-h-screen">
            {/* Contenedor principal ajustado para móviles y escritorio */}
            <div className="flex flex-col lg:flex-row mt-1 gap-6 items-center">
                {/* Sección izquierda para imagen/GIF */}
                <div className="w-full lg:w-1/2 flex items-center justify-center">
                    <img 
                        src="/incendio.gif" // Ruta del GIF en la carpeta `public/`
                        alt="Animación explicativa"
                        className="w-72 lg:w-full h-auto rounded-lg shadow-2xl"
                    />
                </div>

                {/* Sección derecha para texto */}
                <div className="w-full lg:w-1/2 p-4 text-white text-center lg:text-left">
                    <h2 className="text-2xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
                        Detector de Incendios con NDVI
                    </h2>
                    <p className="text-gray-300 leading-relaxed text-sm lg:text-lg">
                        Proyecto que analiza el NDVI en tiempo real con imágenes satelitales (Sentinel-2, Landsat 8 y MODIS)
                    </p>
                    <div className="mt-4">
                        <h3 className="text-2xl font-semibold text-gray-100">Características:</h3>
                        <ul className="list-disc list-inside text-gray-400 space-y-1">
                                        <li>Análisis NDVI en tiempo real con Google Earth Engine</li>
                                        <li>Uso de datos satelitales: Sentinel-2, Landsat 8 y MODIS</li>
                            <li>
                                <a className="text-red-500 hover:underline" href="https://incendio-sigma.vercel.app/" target="_blank" rel="noopener noreferrer">
                                    Link de la página
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrabajosSection2;
